module.exports = __webpack_public_path__ + "static/media/venetian11.797607d6.png";